export const forgotPassword = () => {
  return {
    title: 'Olvidó su Contraseña?',
    subtitle_1: 'Por favor ingrese el correo al que le gustaría enviar la información del restablecimiento de su contraseña.',
    email: 'Correo',
    send: 'Enviar',
    back_to_log_in: 'Regresar a Iniciar Sesión',
    email_not_found: 'El email ingresado es inválido, por favor intenta nuevamente.',
    email_sent: {
      title: 'Reseteo de Contraseña Enviado!',
      subtitle_1: 'Se ha enviado un correo electrónico para restablecer la contraseña. Comprueba tu carpeta de correo no deseado si no estás recibiendo correos electrónicos de MyWork Enterprise.',
      log_in: 'Iniciar Sesión'
    }
  }
}
